import { type FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFilter } from "@/partner/shared/components/Filter";
import { BarChartCard } from "@/partner/shared/components/BarChartCard";
import type { CalendarIntervalValue } from "@/partner/shared/components/AnalyticsCalendarInterval";
import { useAnalyticsVisitorsByDateQuery } from "@/partner/entities/analytics";
import { DownloadReportButton } from "@/partner/features/reports";
import {
  AnalyticsWidgetType,
  ReportTypeType,
} from "@/types/graphql/partner.generated";

export const AnalyticsVisitorsByDateChart: FC = () => {
  const { t } = useTranslation();
  const { filter } = useFilter();
  const [calendarInterval, setCalendarInterval] =
    useState<CalendarIntervalValue>();

  const { data, loading, error } = useAnalyticsVisitorsByDateQuery({
    fetchPolicy: "no-cache",
    variables: {
      filter: filter as never,
      calendarInterval: calendarInterval as never,
    },
  });

  return (
    <BarChartCard
      title={t("analytics.views.chartVisitorsByDate")}
      chart={data?.analyticsViews.visitorsByDate}
      loading={loading}
      error={error}
      dateFrom={filter.dateFrom}
      dateTo={filter.dateTo}
      onChangeCalendarInterval={setCalendarInterval}
      downloadButton={
        <DownloadReportButton
          variant="card"
          type={ReportTypeType.AnalyticsWidgetType}
          widget={AnalyticsWidgetType.VisitorsByDateType}
          filter={filter}
          variables={{ calendarInterval }}
        />
      }
    />
  );
};
